
import React from 'react';
export const Uiw = props => (
  <svg viewBox="0 0 20 20" {...props}><path d="M5.97550739,0 L10.4510148,3.41834667 L8.74152308,8.94934776 L3.20949171,8.94934776 L1.5,3.41834667 L5.97550739,0 Z M5.97550739,20 L1.5,16.5816533 L3.20949171,11.0506522 L8.74152308,11.0506522 L10.4510148,16.5816533 L5.97550739,20 Z M18.5,12.9678909 L13.2386426,14.7649021 L9.98686188,10.0599974 L13.2385083,5.35519519 L18.5,7.15237223 L18.5,12.9678909 Z" fillRule="evenodd" /></svg>
);
